module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"goToLandingPage":"Go to landing page","viewReport":"View report","editLandingPage":"Edit","renameLandingPage":"Rename","deleteLandingPage":"Delete","copy":"Make a copy","copyLink":"Copy link"}}')
  delete Component.options._Ctor
}
